import { Button, FormGroup, Grid } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { DropzoneDialog } from 'material-ui-dropzone'
import React, { useState } from 'react'
import getPayeService from '../../api/envService'
import { DB_ENDPOINT } from '../../api/endpoints'
import InputText from '../common/input-text'
import TextField from '@material-ui/core/TextField'

export function RunScript() {
  const [scriptName, setScriptName] = useState('')
  const handleSave = () => {
    getPayeService().postChildren({}, DB_ENDPOINT, scriptName)
  }
  return (
    <Grid container style={{ marginTop: 30 }}>
      <Grid item xs={3}>
        <Typography data-test={'Import Users'} variant="h5" style={{ lineHeight: 1.8 }}>
          Script
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <TextField value={scriptName} onChange={e => setScriptName(e.target.value)}></TextField>
      </Grid>
      <Grid xs={6} style={{ marginLeft: 10 }}>
        <FormGroup>
          <Button variant="contained" color="primary" onClick={handleSave} data-test="choose-file">
            Lancer
          </Button>
        </FormGroup>
      </Grid>
    </Grid>
  )
}
